import React from "react";
export const NewsPageLazy = React.lazy(() => import("./index"));
